import { certificateData, educationData, educationPopUpData, experienceData } from "../qualification/Data";

export const searchData = [
    {
        id: 1,
        name: "React Portfolio Website",
        type: "Project",
        icon: "📁",
        section: "projects",
        link: "/projects",
        textOnLink: "View Project"
    },
    {
        id: 2,
        name: "Town of Apex Citizen Engagement Forms",
        type: "Project",
        icon: "📁",
        section: "projects",
        link: "/projects",
        textOnLink: "View Project"
    },

    {
        id: 3,
        name: "React",
        type: "Skill",
        icon: "⚛️",
        section: "skills",
        description: `
Vijay has 3+ years experience in React.

Used to build scalable UI applications with:
• Hooks
• Redux
• Reusable components

Used in projects:
• Town of Apex Citizen Engagement Forms
• Portfolio Website
`
    },
    {
        id: 4,
        name: "JavaScript",
        type: "Skill",
        icon: "🟨",
        section: "skills",
        description: `
Experience with modern JavaScript including:
• ES6+
• Async/Await
• API integration
• DOM manipulation
`
    },
    {
        id: 5,
        name: "SQL Server",
        type: "Skill",
        icon: "🗄️",
        section: "skills"
    },

    {
        id: 7,
        name: "Software Engineer - SEW",
        type: "Experience",
        icon: "💼",
        section: "experience",
        description: `
Working on enterprise utility portals.

Technologies:
• React
• ASP.NET Core
• SQL Server
`,
    },
    {
        id: 9,
        name: "Prop Chains / Prop Drilling",
        type: "Blog",
        icon: "✍️",
        section: "blog",
        link: "https://clubofdevelopers.blogspot.com/2024/10/prop-chains-prop-drilling.html",
        textOnLink: "Read Blog"
    },

    {
        id: 10,
        name: "Contact",
        type: "About / Contact",
        icon: "📞",
        section: "contact",
        description: `📧 Email
vskumar12346869@gmail.com

💼 LinkedIn
https://www.linkedin.com/in/vijay-sharma-227b5a124/

💻 GitHub
https://github.com/clubofdevelopers

📍 Location
Noida, India

🚀 Open to Software Development opportunities.`
    },

    {
        id: 11,
        name: "About Me",
        type: "Section",
        icon: "👤",
        section: "about"
    },
    {
        id: 12,
        name: "Resume",
        type: "Section",
        icon: "📄",
        section: "resume",
        description: `View my resume and work experience.`,
        link: "https://clubofdevelopers.github.io/vijay_latest__resume.pdf",
        textOnLink: "View Resume"
    },
    {
        id: 14,
        name: "Testimonials",
        type: "Section",
        icon: "💬",
        section: "testimonials"
    },

    {
        id: 15,
        name: "HTML",
        type: "Skill",
        icon: "🌐",
        section: "skills"

    },
    {
        id: 16,
        name: "CSS",
        type: "Skill",
        icon: "🎨",
        section: "skills"

    },
    {
        id: 17,
        name: "Node.js",
        type: "Skill",
        icon: "🟢",
        section: "skills"

    },
    {
        id: 18,
        name: "Git",
        type: "Skill",
        icon: "🔗",
        section: "skills"

    },
    {
        id: 21,
        name: "Real Estate Site",
        type: "Project",
        icon: "📁",
        section: "projects"
    },
    {
        id: 22,
        name: "Intro video modal",
        type: "Personal Information",
        icon: "🎥",
        section: "about",
        introVideo: true,
        textOnLink: "View Intro Video"
    },
    {
        id: 6,
        name: certificateData[0].title,
        description: certificateData[0].overview,
        type: "Certificate",
        icon: "🏆",
        section: "certificates",
        link: 'static/media/Python.cf51910f9c23323d1bd7.jpg',
        textOnLink: "View Certification"
    },
    {
        id: 24,
        name: certificateData[1].title,
        description: certificateData[1].overview,
        type: "Certificate",
        icon: "🏅",
        section: "certificates",
        link: "/static/media/Coursera.4053ee1ba91d33aba949.jpg",
        textOnLink: "View Certification"
    },
    {
        id: 25,
        name: certificateData[2].title,
        description: certificateData[2].overview,
        type: "Certificate",
        icon: "🏅",
        section: "certificates",
        link: "/static/media/Hakerank.7163da8f0fe56b39aa26.png",
        textOnLink: "View Certification"
    },
    {
        id: 23,
        name: certificateData[3].title,
        description: certificateData[3].overview,
        type: "Certificate",
        icon: "🏅",
        section: "certificates",
        link: "/static/media/CodingNinza.a35c63dfcdf9e90ae6af.jpg",
        textOnLink: "View Certification"
    },
    {
        name: `${educationPopUpData[0].title} (${educationPopUpData[0].duration})`,
        openDialog: true,
        item: educationPopUpData[0],
        onClose: null,
        id: educationPopUpData[0].id,
        type: "Education",
        icon: "🎓",
        section: "education"
    },
    {
        name: `${educationPopUpData[1].title} (${educationPopUpData[1].duration})`,
        openDialog: true,
        item: educationPopUpData[1],
        onClose: null,
        id: educationPopUpData[1].id,
        type: "Education",
        icon: "🎓",
        section: "education"
    },
    {
        name: `${educationPopUpData[2].title} (${educationPopUpData[2].duration})`,
        openDialog: true,
        item: educationPopUpData[2],
        onClose: null,
        id: educationPopUpData[2].id,
        type: "Education",
        icon: "🎓",
        section: "education"
    },
    {
        name: `${educationPopUpData[3].title} (${educationPopUpData[3].duration})`,
        openDialog: true,
        item: educationPopUpData[3],
        onClose: null,
        id: educationPopUpData[3].id,
        type: "Education",
        icon: "🎓",
        section: "education"
    }

];